/**
 * Shared RASTER-asset glue (ADR-0102 · web-only) — the post-processing every content type runs over a Vite
 * `?url` glob (pets, backgrounds, each skin hero). The glob ITSELF cannot live here: `import.meta.glob` needs
 * a string LITERAL at the call site (Vite resolves it at build), so each content type keeps its own one-line
 * glob next to its art and pipes the result through these helpers. This is the hero-agnostic art glue (see
 * art/index.ts), so the shared transform belongs in `art/`, not copied per type.
 */

/** A `…/<stem>.webp` path → its slug (the filename stem), or undefined if the path has no usable name. */
export function slugOf(path: string): string | undefined {
  return path
    .split('/')
    .pop()
    ?.replace(/\.webp$/, '');
}

/** A `?url` glob's `path → url` record → a `slug → url` map (filename stem, sans `.webp`, is the slug). */
export function bySlug(glob: Record<string, unknown>): Readonly<Record<string, string>> {
  const out: Record<string, string> = {};
  for (const [path, url] of Object.entries(glob)) {
    const slug = slugOf(path);
    if (slug && typeof url === 'string') out[slug] = url;
  }
  return out;
}

/** Build a `slug → url | undefined` accessor straight from a flat `?url` glob (the pets/backgrounds shape). */
export function slugResolver(glob: Record<string, unknown>): (slug: string) => string | undefined {
  const map = bySlug(glob);
  return (slug) => map[slug];
}
